
/* injects from baggage-loader */


import TamanduaCanvasTpl from './tamandua-canvas.html';
import TamanduaCanvasController from './tamandua-canvas.controller';

export default class TamanduaCanvasComponent {
    constructor() {
        this.templateUrl = TamanduaCanvasTpl;
        this.controller = TamanduaCanvasController;
        this.bindings = {
            model: "=",
            squads: "=",
            disabled: "=",
            players: "=",
            rows: "=",
            columns: "=",
            hasRuler: "=",
            counterHidden: "=",
            onReset: "&"
        };
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/tamandua-canvas/tamandua-canvas.component.js